// extracted by mini-css-extract-plugin
export default {"groupChatContainer":"ZjYcd4rCNuY5b8A0_ei6"};